import { ALERT_MODAL_STATUS } from '../../../../constant/Common/Modal/Alert/status';
import convertInputData from './convertInputData';
import { EDIT_MODE } from '../../../../constant/Safety/Common/mode';
import checkContainerNumberConstraint from '../../../Common/Validator/Handler/checkContainerNumberConstraint';
import { ERROR_INVALID_CONTAINER_NUMBER } from '../../../../constant/Common/Error/message';
import updateButtonDisabled from '../../../Common/Controller/Handler/updateButtonDisabled';
import uploadMultipleFile from '../../Common/Handler/uploadMultipleFile';

const saveDamageReport = ({
  seq,
  modalType,
  handleSubmit,
  postDamageReportMutator,
  setAlertOptions,
  imageFileList,
  damagePatchMutator,
  saveButtonRef,
}) => {
  const { setIsOpenAlert, setAlertInfo } = setAlertOptions;

  handleSubmit(async submitData => {
    if (saveButtonRef)
      updateButtonDisabled({ ref: saveButtonRef, disabled: true });

    const inputData = { ...submitData };
    const fileList = [];

    /** Handling Truck # / Chassis # */
    inputData.trk_no = inputData.isNGLTruck
      ? inputData.trk_no_auto_complete
      : inputData.trk_no_text;

    inputData.ch_no = inputData.isNGLChassis
      ? inputData.ch_no_auto_complete
      : inputData.ch_no_text;

    /** Chassis No / Truck No null validation */
    if (!inputData?.ch_no && !inputData?.trk_no) {
      if (saveButtonRef)
        updateButtonDisabled({ ref: saveButtonRef, disabled: false });
      setIsOpenAlert(prev => true);
      setAlertInfo(prev => ({
        status: ALERT_MODAL_STATUS?.ERROR,
        message: 'One of the Truck # / Classis # must be entered.',
      }));
      return;
    }

    if (!checkContainerNumberConstraint({ containerNo: inputData?.cont_no })) {
      if (saveButtonRef)
        updateButtonDisabled({ ref: saveButtonRef, disabled: false });
      setIsOpenAlert(prev => true);
      setAlertInfo(prev => ({
        status: ALERT_MODAL_STATUS?.ERROR,
        message: ERROR_INVALID_CONTAINER_NUMBER,
      }));
      return;
    }

    const convertedData = convertInputData({
      dateList: ['report_date'],
      timeList: ['report_time'],
      possibleEmptyStringList: [
        'trk_no',
        'driver',
        'trk_plate_no',
        'trk_ordometer',
        'cont_no',
        'cont_seal',
        'ch_no',
        'ch_plate_no',
        'yard_location',
        'trk_others',
        'ch_others',
      ],
      autoCompleteList: ['driver', 'trk_no', 'ch_no'],
      inputData,
    });

    /** Photo File Handling */
    imageFileList?.forEach(imageFile => {
      fileList.push(
        imageFile?.fileInfo?.lastModified
          ? {
              file_name: imageFile?.fileInfo?.name,
              file_url: imageFile?.fileInfo,
            }
          : {
              file_name: imageFile?.fileInfo?.file_name,
              file_url: imageFile?.fileInfo?.file_url,
            },
      );
    });

    convertedData.photo = fileList;

    /** Post */
    if (modalType === EDIT_MODE?.add) {
      // Post -> Upload -> Patch
      // Delete file-related data temporarily
      const photo = convertedData?.photo;
      delete convertedData?.photo;

      /** 1. Post */
      postDamageReportMutator(
        {
          postData: convertedData,
          buttonRef: saveButtonRef,
        },
        {
          onSuccess: async responseData => {
            const createdSeq = responseData?.data?.seq;

            // 2. Upload
            const manipulatedData = await uploadMultipleFile({
              inputData: {
                ...convertedData,
                doc: photo,
              },
              uploadPath: `safety/damage_report/${createdSeq}`,
            });

            // 3. Patch
            damagePatchMutator({
              seq: createdSeq,
              patchData: {
                ...manipulatedData,
                photo: manipulatedData?.doc,
              },
              buttonRef: saveButtonRef,
            });
          },
        },
      );
      return;
    }

    /** Patch */
    if (modalType === EDIT_MODE?.edit && seq) {
      // Upload -> Patch
      const manipulatedData = await uploadMultipleFile({
        inputData: {
          ...convertedData,
          doc: convertedData?.photo,
        },
        uploadPath: `safety/damage_report/${seq}`,
      });
      damagePatchMutator({
        seq,
        patchData: {
          ...convertedData,
          photo: manipulatedData?.doc,
        },
        buttonRef: saveButtonRef,
      });
    }
  })();
};

export default saveDamageReport;
